const useInputHelpers = () => {
  const numberOnly = (evt) => {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (
      (charCode > 1775 && charCode < 1786) ||
      (charCode > 1631 && charCode < 1642) ||
      (charCode > 47 && charCode < 58)
    ) {
      return true;
    } else {
      evt.preventDefault();
    }
  };

  const validateNationalCode = (code) => {
    if (code && code != "0000000000") {
      let en_code = fa2en(code);
      if (!/^\d{10}$/.test(en_code)) {
        return false;
      } else {
        const check = +en_code[9];
        const sum =
          Array(9)
            .fill()
            .map((_, i) => +en_code[i] * (10 - i))
            .reduce((x, y) => x + y) % 11;
        return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
      }
    } else return true;
  };

  const validateMobile = (mobile) => {
    if (mobile.trim()) {
      let en_mobile = fa2en(mobile.trim());
      if (en_mobile[0] == 9 && en_mobile[1] == 8) {
        if (en_mobile.length == 12) {
          return true;
        } else {
          return false;
        }
      } else if (en_mobile[0] == 0) {
        if (en_mobile.length == 11) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  };

  const validateFaChar = (text) => {
    if (text) {
      let newText = text.trim();
      if (/^[\u0600-\u06FF\s]+$/.test(newText)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const validateEmail = (email) => {
    if (email) {
      if (
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]+/.test(email)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const fa2en = (number) => {
    if (number) {
      let num = number.toString();
      var id = {
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
      };
      return num.replace(/[^0-9.]/g, function (w) {
        return id[w] || w;
      });
    }
  };

  const en2fa = (number) => {
    if (number || number == 0) {
      let num = `${number}`;
      var id = {
        0: "۰",
        1: "۱",
        2: "۲",
        3: "۳",
        4: "۴",
        5: "۵",
        6: "۶",
        7: "۷",
        8: "۸",
        9: "۹",
      };
      return num.replace(/[^۰-۹.]/g, function (w) {
        return id[w] || w;
      });
    }
  };

  const formatPrice = (number) => {
    if (number != null || number != undefined) {
      let num = number.toString();
      const price = num.replace(/\B(?=(\d{3})+(?!\d))/g, "/");
      return price;
    }
  };

  const pasteNumber = (event) => {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    const filteredPaste = paste.replace(/[^\d۰-۹]/g, ""); // Remove non-numeric characters
    document.execCommand("insertText", false, filteredPaste);
  };

  return {
    numberOnly,
    validateNationalCode,
    validateMobile,
    validateFaChar,
    validateEmail,
    fa2en,
    en2fa,
    formatPrice,
    pasteNumber,
  };
};
export default useInputHelpers;
